import { Builder } from '@builder.io/react'

import { railBuilderInputs } from '@src/components/Rail/Rail.builder'
import { SKUSelectionRailDefaults } from '@src/components/SKUSelectionRail/SKUSelectionRail.defaults'
import { ANALYTICS_MODULE_INPUT } from '@src/hooks/useClickAction/useClickAction.builder'

import { SKUSelectionRail } from './SKUSelectionRail'

Builder.registerComponent(SKUSelectionRail, {
  name: 'SKUSelectionRail',
  inputs: [
    {
      name: 'railProps',
      friendlyName: 'Rail Config',
      type: 'object',
      subFields: railBuilderInputs,
      defaultValue: SKUSelectionRailDefaults.railProps,
    },
    {
      name: 'items',
      localized: true,
      type: 'array',
      subFields: [
        {
          name: 'blocks',
          type: 'array',
          hideFromUI: true,
          defaultValue: SKUSelectionRailDefaults.items?.[0]?.blocks,
        },
        {
          name: 'sku',
          type: 'string',
          defaultValue: SKUSelectionRailDefaults.items?.[0]?.sku,
        },
        {
          name: 'imageUrl',
          friendlyName: 'Image',
          type: 'file',
          allowedFileTypes: ['jpg', 'jpeg', 'png', 'webp'],
          defaultValue: SKUSelectionRailDefaults.items?.[0]?.imageUrl,
        },
        {
          name: 'imageAlt',
          type: 'string',
          defaultValue: SKUSelectionRailDefaults.items?.[0]?.imageAlt,
        },
        ANALYTICS_MODULE_INPUT,
      ],
      defaultValue: SKUSelectionRailDefaults.items,
    },
    {
      name: 'minSelection',
      type: 'number',
      defaultValue: SKUSelectionRailDefaults.minSelection,
      hideFromUI: true,
    },
    {
      name: 'maxSelection',
      type: 'number',
      defaultValue: SKUSelectionRailDefaults.maxSelection,
      hideFromUI: true,
    },
  ],
})
